import { useI18n } from '@/hooks/web/useI18n';
import { Layout } from '@/utils/routerHelper';
import type { App } from 'vue';
import type { RouteRecordRaw } from 'vue-router';
import { createRouter, createWebHashHistory } from 'vue-router';

const { t } = useI18n();

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard/analysis',
    name: 'Root',
    meta: {
      hidden: true,
    },
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: ':path(.*)', // 相對路徑
        name: 'RedirectChild', // 唯一名稱
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {},
      },
    ],
    meta: {
      hidden: true,
      noTagsView: true,
    },
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true,
    },
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true,
    },
  },
];

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Layout, // 後端 component="#", 代表只有目錄，不對應實際頁面，通常就用 Layout
    meta: {
      title: '首頁',
      icon: 'vi-ant-design:dashboard-filled',
    },
  },
  {
    path: '/web-config',
    name: 'WebConfig',
    component: Layout,
    meta: {
      title: '網頁設定',
      icon: '',
    },
    children: [
      {
        path: '/meals',
        name: 'Meals',
        component: () => import('@/views/WebConfig/Meals.vue'),
        meta: {
          title: '豪華月子餐設定',
          icon: '',
        },
      },
      {
        path: '/blogs',
        name: 'Blogs',
        component: () => import('@/views/WebConfig/Blogs.vue'),
        meta: {
          title: '部落格設定',
          icon: '',
        },
      },
      // {
      //   path: '/feedbacks',
      //   name: 'Feedbacks',
      //   component: () => import('@/views/WebConfig/Feedbacks.vue'),
      //   meta: {
      //     title: '客戶回饋設定',
      //     icon: '',
      //   },
      // },
      // {
      //   path: '/service-experience',
      //   name: 'ServiceExperience',
      //   component: () => import('@/views/WebConfig/ServiceExperience.vue'),
      //   meta: {
      //     title: '服務經歷',
      //     icon: '',
      //   },
      // },
    ],
  },
  {
    path: '/admin-setting',
    name: 'AdminSetting',
    component: Layout,
    meta: {
      title: '管理員設定',
      icon: '',
    },
    children: [
      {
        path: '/permission',
        name: 'Permission',
        component: () => import('@/views/AdminSetting/Permission.vue'),
        meta: {
          title: '權限管理',
          icon: '',
        },
      },
    ],
  },
  {
    path: '/personal-setting',
    name: 'PersonalSetting',
    component: Layout,
    meta: {
      title: '個人設定',
      icon: '',
    },
    children: [
      {
        path: '/personal',
        name: 'Personal',
        component: () => import('@/views/PersonalSetting/Personal.vue'),
        meta: {
          title: '個人設定',
          icon: '',
        },
      },
    ],
  },
  {
    path: '/:path(.*)*',
    redirect: '/404',
    name: '404Page',
    meta: {
      hidden: true,
      breadcrumb: false,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root'];
  router.getRoutes().forEach((route) => {
    const { name } = route;
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name);
    }
  });
};

export const setupRouter = (app: App<Element>) => {
  app.use(router);
};

export default router;
